// v56: CRITICAL - hamburger defensive handler (module scope, must register before any user interaction)
(function _rxHamburgerSetup() {
  function _rxCloseMobileMenu() {
    document.body.classList.remove("menu-open");
    const btn = document.getElementById("nav-toggle");
    const mm = document.getElementById("mobile-menu");
    if (btn) btn.setAttribute("aria-expanded", "false");
    if (mm) {
      mm.setAttribute("inert", "");
      mm.removeAttribute("aria-hidden");
      // v60AI: snap closed with transition:none + explicit transform
      try {
        mm.style.setProperty("transition", "none", "important");
        mm.style.setProperty("transform", "translateX(-100%)", "important");
      } catch(e){}
    }
  }
  function _rxOpenMobileMenu() {
    document.body.classList.add("menu-open");
    const btn = document.getElementById("nav-toggle");
    const mm = document.getElementById("mobile-menu");
    if (btn) btn.setAttribute("aria-expanded", "true");
    if (mm) {
      mm.removeAttribute("inert");
      mm.removeAttribute("aria-hidden");
      // v60AI: force open with transition:none so transform applies INSTANTLY (CSS rule conflict was racing the transition)
      try {
        mm.style.setProperty("transition", "none", "important");
        mm.style.setProperty("transform", "translateX(0)", "important");
        mm.style.setProperty("visibility", "visible", "important");
        mm.style.setProperty("left", "0", "important");
      } catch(e){}
    }
  }
  function _rxToggleMobileMenu(e) {
    const mm = document.getElementById("mobile-menu");
    if (!mm) return;
    if (e) e.preventDefault();
    // v60BJ: De-dupe double-fire. The nav-toggle has BOTH an inline onclick
    // AND a fallback addEventListener (and initMobileMenu binds another on the
    // homepage). On non-home pages exactly two handlers fire for one physical
    // click -> toggle ran twice -> open-then-close -> looked like "nothing
    // happened". Collapse all handlers of the same user gesture into one toggle.
    var now = (e && typeof e.timeStamp === "number" && e.timeStamp) ? e.timeStamp : Date.now();
    if (_rxToggleMobileMenu._lastTs != null && Math.abs(now - _rxToggleMobileMenu._lastTs) < 350) return;
    _rxToggleMobileMenu._lastTs = now;
    // v60BJ: decide purely from the reliable body.menu-open state
    if (document.body.classList.contains("menu-open")) _rxCloseMobileMenu();
    else _rxOpenMobileMenu();
  }
  // Expose globally so inline onclick can also call them
  window._rxToggleMobileMenu = _rxToggleMobileMenu;
  window._rxCloseMobileMenu = _rxCloseMobileMenu;
  window._rxOpenMobileMenu = _rxOpenMobileMenu;

  function attach() {
    document.addEventListener("click", function(e) {
      // 3-line close button inside the mobile menu
      if (e.target.closest("#mm-close")) {
        e.preventDefault();
        e.stopPropagation();
        _rxCloseMobileMenu();
        return;
      }
      // v60AG: removed nav-toggle document-delegated handler. Inline onclick on the button handles toggling. Having both caused double-fire = open-then-close.
      // Any link click inside the open mobile menu closes it
      if (document.body.classList.contains("menu-open")) {
        if (e.target.closest("#mobile-menu a")) {
          _rxCloseMobileMenu();
        }
      }
      // v60Y: Click on the dark backdrop (outside the mobile menu and outside the hamburger) closes
      if (document.body.classList.contains("menu-open")) {
        var insideMenu = e.target.closest("#mobile-menu");
        var onToggle = e.target.closest("#nav-toggle");
        var onClose = e.target.closest("#mm-close");
        if (!insideMenu && !onToggle && !onClose) {
          _rxCloseMobileMenu();
        }
      }
    }, false);
    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape" && document.body.classList.contains("menu-open")) {
        _rxCloseMobileMenu();
      }
      // v60X: Escape closes search overlay
      if (e.key === "Escape") {
        var ov = document.getElementById("rxs-search-overlay");
        if (ov && ov.classList.contains("open")) { ov.classList.remove("open"); }
      }
    });
    // v60X: Collapsible mobile menu triggers (About, Brands)
    document.addEventListener("click", function(e) {
      var trig = e.target.closest(".mm-collapsible-trigger");
      if (trig) {
        e.preventDefault();
        e.stopPropagation();
        var targetId = trig.getAttribute("data-mm-target");
        var sub = document.getElementById(targetId);
        if (sub) {
          var isCollapsed = sub.getAttribute("data-mm-collapsed") === "true";
          sub.setAttribute("data-mm-collapsed", isCollapsed ? "false" : "true");
          trig.setAttribute("aria-expanded", isCollapsed ? "true" : "false");
        }
      }
    }, false);
    // v60X: Click outside search card closes overlay (backdrop click)
    document.addEventListener("click", function(e) {
      var ov = document.getElementById("rxs-search-overlay");
      if (!ov || !ov.classList.contains("open")) return;
      // If click target is the overlay itself (not the card or its children), close
      if (e.target === ov) {
        ov.classList.remove("open");
      }
    }, false);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attach);
  } else {
    attach();
  }
})();

  // ============================================================
  // PRODUCT DATA - live from Shopify.
  // Rendered server-side into window.RXB_PRODUCTS by sections/rxb-catalog.liquid.
  // ============================================================
  function rxProductPageUrl(id) {
    // v62: product ids ARE Shopify handles, emitted live by sections/rxb-catalog.liquid.
    return id ? "/products/" + id : null;
  }

  // v62: Live catalog. Populated server-side by sections/rxb-catalog.liquid from the
  // Shopify brand collections. Liquid only yields products published to the Online
  // Store, so drafted and archived products are excluded automatically.
  // No hardcoded fallback list on purpose - a frozen list goes stale and keeps
  // showing SKUs that have since been pulled from the store.
  const PRODUCTS = (typeof window !== "undefined" && Array.isArray(window.RXB_PRODUCTS))
    ? window.RXB_PRODUCTS.slice()
    : [];


  // Map the tier toggle's activeTier value (data-tier 50/58/65/67) to a tiers key.
  // 50→t1, 58→t2, 65→t3, 67→t4; default t1.
  function rxTierKey(at) { return at >= 67 ? "t4" : at >= 65 ? "t3" : at >= 58 ? "t2" : "t1"; }
  // Tier case price for a product id at the active tier (falls back to casePrice/price).
  function rxTierCase(id, at) {
    var p = PRODUCTS.find(function(x){ return x.id === id; });
    if (p && p.tiers && p.tiers[rxTierKey(at)] != null) return p.tiers[rxTierKey(at)];
    return p ? (p.casePrice || p.price) : 0;
  }
  // MSRP (retail) case value for a product id (falls back to casePrice/price).
  function rxMsrpCase(id) {
    var p = PRODUCTS.find(function(x){ return x.id === id; });
    if (p && p.msrpCase != null) return p.msrpCase;
    return p ? (p.casePrice || p.price) : 0;
  }

  // append width param for image transforms
  PRODUCTS.forEach(p => {
    if (p.imgFull) {
      // v62: live Shopify CDN url already carries ?v=, so append the width transform
      p.imageUrl = p.imgFull + "&width=400";
      p.thumbUrl = p.imgFull + "&width=120";
    } else {
      p.imageUrl = "";
      p.thumbUrl = "";
    }
  });

  // ============================================================
  // IMAGE LOAD DETECTION, fall back to SVG silhouettes if blocked
  // ============================================================
  function detectImages() {
    return new Promise(resolve => {
      const probe = new Image();
      let done = false;
      const finish = (ok) => { if (done) return; done = true; resolve(ok); };
      probe.onload = () => finish(true);
      probe.onerror = () => finish(false);
      // very small image probe for speed
      if (!PRODUCTS.length) { finish(false); return; }
      probe.src = PRODUCTS[0].imgFull ? PRODUCTS[0].imgFull + "&width=20" : "";
      if (!probe.src) { finish(false); return; }
      setTimeout(() => finish(false), 4500);
    });
  }

  // ============================================================
  // SVG fallback, vendor-aware silhouettes
  // ============================================================
  function svgFallback(p) {
    const v = (p.vendor || "").toLowerCase();
    const t = (p.productType || "").toLowerCase();
    if (v.includes("king")) {
      const isShot = /energy|shot/i.test(t);
      const bottleColor = isShot ? "#C81E2E" : "#F8B60F";
      return `<svg width="48" height="120" viewBox="0 0 48 120" xmlns="http://www.w3.org/2000/svg">
        <rect x="18" y="0" width="12" height="6" fill="#1a1a1a"/>
        <path d="M6 14 Q6 10 10 10 L38 10 Q42 10 42 14 L42 116 Q42 120 38 120 L10 120 Q6 120 6 116 Z" fill="${bottleColor}"/>
        <rect x="10" y="32" width="28" height="50" fill="#1a1a1a"/>
        <text x="24" y="56" text-anchor="middle" font-family="Helvetica" font-weight="900" font-size="11" fill="#F8B60F">KING K</text>
      </svg>`;
    }
    if (v.includes("güd") || v.includes("gud")) {
      let palette = ["#FF8B5C", "#B23A6B"];
      if (/baja/i.test(p.title)) palette = ["#5DD3D8", "#1B7A8C"];
      if (/pink/i.test(p.title)) palette = ["#FF6B9D", "#7B1F4D"];
      if (/raw/i.test(p.title)) palette = ["#9B7B5A", "#4A3826"];
      return `<svg width="48" height="120" viewBox="0 0 48 120" xmlns="http://www.w3.org/2000/svg">
        <rect x="20" y="0" width="8" height="6" fill="#3a1015"/>
        <path d="M14 6 Q14 4 16 4 L32 4 Q34 4 34 6 L34 18 L42 24 L42 116 Q42 120 38 120 L10 120 Q6 120 6 116 L6 24 L14 18 Z" fill="${palette[0]}"/>
        <text x="24" y="68" text-anchor="middle" font-family="Helvetica" font-weight="900" font-size="14" fill="#fff">GÜD</text>
      </svg>`;
    }
    if (t.includes("powder") || t.includes("blend")) {
      return `<svg width="80" height="120" viewBox="0 0 80 120" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 16 L70 16 Q72 16 72 18 L74 116 Q74 120 70 120 L10 120 Q6 120 6 116 L8 18 Q8 16 10 16 Z" fill="#1A3A12"/>
        <path d="M10 16 L20 8 L60 8 L70 16" fill="#0F2200"/>
        <text x="40" y="60" text-anchor="middle" font-family="Helvetica" font-weight="900" font-size="14" fill="#F8B60F">GRH</text>
      </svg>`;
    }
    if (t.includes("capsule")) {
      return `<svg width="64" height="120" viewBox="0 0 64 120" xmlns="http://www.w3.org/2000/svg">
        <rect x="14" y="0" width="36" height="14" fill="#F8B60F"/>
        <path d="M6 14 L58 14 L60 116 Q60 120 56 120 L8 120 Q4 120 4 116 Z" fill="#1A3A12"/>
        <text x="32" y="62" text-anchor="middle" font-family="Helvetica" font-weight="900" font-size="11" fill="#F8B60F">GRH CAPS</text>
      </svg>`;
    }
    return `<svg width="48" height="120" viewBox="0 0 48 120"><rect width="48" height="120" fill="#1A3A12"/></svg>`;
  }

  // ============================================================
  // HELPERS
  // ============================================================
  function fmtMoney(n) {
    if (n == null || isNaN(n)) return ",";
    return "$" + Math.round(n).toLocaleString();
  }
  function fmtMoneyDec(n) {
    if (n == null || isNaN(n)) return ",";
    return "$" + (Math.round(n * 100) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function vendorClass(v) {
    if (!v) return "vt-grh";
    const x = v.toLowerCase();
    if (x.includes("king")) return "vt-king-k";
    if (x.includes("güd") || x.includes("gud")) return "vt-gud";
    if (x.includes("grass")) return "vt-grass";
    if (x.includes("lucy")) return "vt-lucy";
    return "vt-grh";
  }
  function pickBadge(tags) {
    if (!tags || !tags.length) return "";
    const t = tags.map(x => (x || "").toUpperCase());
    if (t.includes("JUST LAUNCHED")) return '<span class="vendor-tag" style="background:#C81E2E;">★ Just Launched</span>';
    if (t.includes("BEST SELLER") || t.includes("TOP SELL")) return '<span class="vendor-tag" style="background:var(--gold);color:var(--ink);">★ Best Seller</span>';
    if (t.includes("NEW")) return '<span class="vendor-tag" style="background:#C81E2E;">New</span>';
    if (t.includes("FOUNDER\'S PICK")) return '<span class="vendor-tag" style="background:var(--green-mid);color:var(--gold);">Founder\'s Pick</span>';
    if (t.includes("CUSTOMER FAVE")) return '<span class="vendor-tag" style="background:#B23A6B;">Customer Fave</span>';
    if (t.includes("HIGH POTENCY")) return '<span class="vendor-tag" style="background:var(--ink);color:var(--gold);">High Potency</span>';
    if (t.includes("BEGINNER FRIENDLY")) return '<span class="vendor-tag" style="background:#1A8845;">Beginner</span>';
    if (t.includes("SOCIAL VIBE")) return '<span class="vendor-tag" style="background:#FF8B5C;">Social Vibe</span>';
    if (t.includes("HOT")) return '<span class="vendor-tag" style="background:#C81E2E;">Hot</span>';
    if (t.includes("STAFF PICK")) return '<span class="vendor-tag" style="background:var(--green-mid);color:var(--gold);">Staff Pick</span>';
    return "";
  }

  // ============================================================
  // PRODUCT GRID
  // ============================================================
  let activeFilter = "all";
  let activeSubFilter = null; // v60BA: secondary filter from data-subfilter on sub-chips

  function productMatchesFilter(p, filter, subFilter) {
    // v60BA: helper for keyword matching against a single filter token
    function matchToken(tok) {
      if (!tok || tok === "all") return true;
      const f = String(tok).toLowerCase();
      const v = (p.vendor || "").toLowerCase();
      const t = (p.productType || "").toLowerCase();
      const title = (p.title || "").toLowerCase();
      const tags = (p.tags || []).map(x => String(x).toLowerCase());
      if (f === "extract" || f === "extracts") return /extract/i.test(t) || /extract/i.test(title);
      if (f === "energy" || f === "energy-shot" || f === "energy-shots" || f === "shot" || f === "shots") return /energy|shot/i.test(t);
      if (f === "kava") return /kava/i.test(t) || /kava/i.test(title) || v.includes("güd") || v.includes("gud");
      if (f === "powder" || f === "powders") return /powder/i.test(t);
      if (f === "capsule" || f === "capsules") return /capsule/i.test(t);
      if (f === "thc") return /thc|hemp|gumm|vape|delta/i.test(t) || v.includes("lucy") || v.includes("grass");
      if (f === "grassroots harvest" || f === "grassroots" || f === "grass") return v.includes("lucy") || v.includes("grass") || v.includes("grassroots");
      // tag-based match fallback
      if (tags.includes(f)) return true;
      return v.includes(f);
    }
    // vendor / primary filter must match
    if (!matchToken(filter)) return false;
    // v60BA: AND sub-filter (data-subfilter on sub-chips, e.g. extracts/energy-shot/powders/capsules)
    if (subFilter && subFilter !== "all" && !matchToken(subFilter)) return false;
    return true;
  }

  function renderProducts() {
    // v60BW: guard for non-home pages where #product-grid doesn't exist
    const grid = document.getElementById("product-grid");
    if (!grid) return;
    const list = PRODUCTS.filter(p => productMatchesFilter(p, activeFilter, activeSubFilter));
    // v62: no pinned product. Ordering follows the live catalog feed.
    const PIN_ID = null;
    const pinIdx = PIN_ID ? list.findIndex(p => p.id === PIN_ID) : -1;
    if (pinIdx > 0) {
      const pinned = list.splice(pinIdx, 1)[0];
      list.unshift(pinned);
    }
    const visEl = document.getElementById("visible-count");
    if (visEl) visEl.textContent = list.length;

    if (!list.length) {
      grid.innerHTML = '<div class="catalog-loading">No products match this filter.</div>';
      return;
    }

    grid.innerHTML = list.map(p => {
      const cls = vendorClass(p.vendor);
      const badge = pickBadge(p.tags || []);
      const showCase = p.casePrice != null;
      var rxT1 = (p.tier1 != null) ? p.tier1 : p.casePrice;
      var rxT1s = (p.tier1 != null) ? p.tier1 : p.price;
      const priceLine = showCase
        ? `<div class="case">${p.casePack}</div><div class="price">${fmtMoney(rxT1)}<small>Tier 1 · could be lower</small></div>`
        : `<div class="case">Single unit</div><div class="price">${fmtMoneyDec(rxT1s)}<small>Tier 1 · could be lower</small></div>`;

      // v46: link the card image + title directly to the Shopify product page (rebel-x template).
      const pageUrl = rxProductPageUrl(p.id);
      const linkOpen  = pageUrl ? `<a class="product-cardlink" href="${pageUrl}" aria-label="View ${p.title.replace(/"/g, "&quot;")} product page">` : `<div class="product-cardlink">`;
      const linkClose = pageUrl ? `</a>` : `</div>`;

      return `
        <div class="product" data-id="${p.id}" data-page-url="${pageUrl || ""}">
          <div class="product-tagrow">
            <div class="tagrow-right pack-badge-top">${p.casePack}</div>
          </div>
          ${linkOpen}
          <div class="imagecanvas">
            ${badge ? `<div class="imgbadge">${badge}</div>` : ""}
            <img class="photo" src="${p.imageUrl}" alt="${p.title}" loading="lazy" decoding="async" fetchpriority="low" onerror="this.style.display='none'; this.nextElementSibling.style.display='grid';" />
            <div class="svg-fallback">${svgFallback(p)}</div>
            <button class="quickadd" title="Add to wholesale order" onclick="RebelX.addToOrder('${p.id}'); event.preventDefault(); event.stopPropagation();">+</button>
            <button class="viewdetail" title="Open full product page" onclick="if(pageUrl=this.closest('.product')?.dataset.pageUrl){window.location.href=pageUrl;event.preventDefault();event.stopPropagation();}else{RebelX.openDetail('${p.id}');event.preventDefault();event.stopPropagation();}" aria-label="Open full product page">↗</button>
          </div>
          <div class="meta">
            <span class="vendor-tag ${cls}" style="align-self:flex-start;">${p.vendor}</span>
            <h4>${p.title}</h4>
            <div class="ptype">${p.productType} · MSRP $${p.price}</div>
            <div class="pricing-row">${priceLine}</div>
          </div>
          ${linkClose}
          <div class="product-cta" onclick="RebelX.addToOrder('${p.id}'); event.preventDefault(); event.stopPropagation();">Add to wishlist →</div>
        </div>
      `;
    }).join("");
  }

  // Filter chip wiring
  function wireCatalogChips() { /* v60CA: named + re-callable so customizer re-renders can re-bind */
    document.querySelectorAll(".chip").forEach(ch => {
      ch.addEventListener("click", () => {
        document.querySelectorAll(".chip").forEach(c => c.classList.remove("active"));
        ch.classList.add("active");
        activeFilter = ch.dataset.filter || "all";
        // v60BA: support sub-filter when chip carries data-subfilter (sub-chips for King K extracts/energy-shot, GRH powders/capsules)
        activeSubFilter = ch.dataset.subfilter || null;
        renderProducts();
      });
    });
  }
  wireCatalogChips(); /* v60CA: preserve original initial-load behavior */

  // ============================================================
  // HERO PRODUCT CARDS
  // ============================================================
  function renderHero() {
    // v60BW: guard for non-home pages where #hero-visual doesn't exist
    const heroEl = document.getElementById("hero-visual");
    if (!heroEl) return;
    const heroSlots = [
      { product: PRODUCTS.find(p => p.id === "king-k-platinum-liquid-kratom-extract"), ribbon: '<span class="ribbon" style="background:#C81E2E;">New</span>' },
      { product: PRODUCTS.find(p => p.id === "gud-tonics-kava-kratom-extract-pink-sunset"), ribbon: '<span class="ribbon gold">Customer Fave</span>' },
      { product: PRODUCTS.find(p => p.id === "joy-blend-kratom-powder"), ribbon: '<span class="ribbon green">Best Seller</span>' }
    ];
    heroEl.innerHTML = heroSlots.map((slot, i) => {
      const p = slot.product;
      if (!p) return "";
      const unitPrice = "could be lower";
      const heroT1 = (p.tier1 != null) ? p.tier1 : p.casePrice;
      const showPrice = p.casePrice ? fmtMoney(heroT1) : fmtMoneyDec(p.price);
      const packLabel = p.casePack ? `/${p.casePack.toLowerCase().replace(/^box of |^case of /, "box of ")}` : "";
      return `
        <div class="hero-card c${i+1}" data-id="${p.id}" role="button" tabindex="0" aria-label="Quick view ${p.title}" onclick="RebelX.openQuickView('${p.id}');" onkeydown="if(event.key==='Enter'||event.key===' '){event.preventDefault();RebelX.openQuickView('${p.id}');}">
          ${slot.ribbon}
          <div class="pviz">
            <img src="${p.imageUrl}" alt="${p.title}" loading="eager" decoding="async" fetchpriority="${i===0?'high':'auto'}" onerror="this.style.display='none'; this.nextElementSibling.style.display='grid';" />
            <div class="svg-fallback">${svgFallback(p)}</div>
          </div>
          <h4>${p.title.length > 32 ? p.title.slice(0, 30) + "…" : p.title}</h4>
          <div class="meta">
            <div class="price">${showPrice}<small style="font-weight:600;font-size:10px;color:var(--muted);"> ${packLabel}</small></div>
            <div class="pack">${unitPrice}</div>
          </div>
        </div>`;
    }).join("");
  }


  // ============================================================
  // APPLY FORM, multi-step wizard
  // ============================================================
  window.RebelX = window.RebelX || {};
  window.RebelX.applyStep = function(targetStep) {
    const form = document.getElementById("rxb-apply-form");
    if (!form) return;
    // Validate current step before moving forward
    const currentActive = form.querySelector(".apply-step.active");
    const currentStep = currentActive ? parseInt(currentActive.dataset.stepContent) : 1;
    if (targetStep > currentStep) {
      // Validate fields in the current step
      const inputs = currentActive.querySelectorAll("input[required], select[required], textarea[required]");
      let firstInvalid = null;
      inputs.forEach(inp => {
        if (!inp.checkValidity()) {
          inp.reportValidity();
          if (!firstInvalid) firstInvalid = inp;
        }
      });
      if (firstInvalid) return;
    }

    // Switch active step content
    form.querySelectorAll(".apply-step").forEach(s => s.classList.remove("active"));
    const next = form.querySelector('.apply-step[data-step-content="' + targetStep + '"]');
    if (next) next.classList.add("active");

    // Update stepper indicator
    form.querySelectorAll(".stepper .step").forEach(s => {
      const stepNum = parseInt(s.dataset.step);
      s.classList.remove("active", "done", "upcoming");
      if (stepNum === targetStep) s.classList.add("active");
      else if (stepNum < targetStep) s.classList.add("done");
      else s.classList.add("upcoming");
    });

    // If moving to review step, render a summary
    if (targetStep === 4) RebelX.renderApplyReview();

    // Scroll the form top into view
    document.getElementById("apply").scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // Allow clicking back on completed stepper headers
  document.addEventListener("DOMContentLoaded", function() {
    const form = document.getElementById("rxb-apply-form");
    if (!form) return;
    form.querySelectorAll(".stepper .step").forEach(s => {
      s.addEventListener("click", function() {
        if (this.classList.contains("done")) {
          RebelX.applyStep(parseInt(this.dataset.step));
        }
      });
    });
  });

  window.RebelX.renderApplyReview = function() {
    const form = document.getElementById("rxb-apply-form");
    if (!form) return;
    const data = new FormData(form);
    const get = k => (data.get(k) || "").toString().trim();
    const getAll = k => data.getAll(k).filter(Boolean);

    const businessHtml = `
      <h4>Business</h4>
      <dl>
        <dt>Business</dt><dd>${get("business_name") || "<span class='review-empty'>,</span>"}${get("dba") ? " (DBA " + get("dba") + ")" : ""}</dd>
        <dt>Contact</dt><dd>${get("first_name")} ${get("last_name")}</dd>
        <dt>Email</dt><dd>${get("email") || "<span class='review-empty'>,</span>"}</dd>
        <dt>Phone</dt><dd>${get("phone") || "<span class='review-empty'>,</span>"}</dd>
        <dt>Website</dt><dd>${get("website") || "<span class='review-empty'>,</span>"}</dd>
        <dt>Ship-to state</dt><dd>${get("state") || "<span class='review-empty'>,</span>"}</dd>
        <dt>Buyer type</dt><dd>${get("buyer_type") || "<span class='review-empty'>,</span>"}</dd>
      </dl>
      <h4>Licensing</h4>
      <dl>
        <dt>Years in biz</dt><dd>${get("years_in_business") || "<span class='review-empty'>,</span>"}</dd>
        <dt>EIN / Tax ID</dt><dd>${get("ein") || "<span class='review-empty'>,</span>"}</dd>
        <dt>License #</dt><dd>${get("license_no") || "<span class='review-empty'>,</span>"}</dd>
        <dt>Resale cert</dt><dd>${get("resale_cert") || "<span class='review-empty'>email or link pending</span>"}</dd>
        <dt>Locations</dt><dd>${get("num_locations") || "<span class='review-empty'>,</span>"}</dd>
      </dl>
      <h4>Order intent</h4>
      <dl>
        <dt>First order</dt><dd>${get("first_order_size") || "<span class='review-empty'>,</span>"}</dd>
        <dt>Monthly volume</dt><dd>${get("monthly_volume") || "<span class='review-empty'>,</span>"}</dd>
        <dt>Brands</dt><dd>${getAll("brand_interest").length ? getAll("brand_interest").join(", ") : "<span class='review-empty'>not specified</span>"}</dd>
        <dt>Timeline</dt><dd>${get("timeline") || "<span class='review-empty'>,</span>"}</dd>
        <dt>Notes</dt><dd>${get("notes") || "<span class='review-empty'>,</span>"}</dd>
      </dl>
    `;
    const reviewEl = document.getElementById("apply-review");
    if (reviewEl) reviewEl.innerHTML = businessHtml;
  };

  // Submit handler, sends to Clay if URL is configured, else falls back to email
  window.RebelX.submitApply = function(e) {
    e.preventDefault();
    const form = document.getElementById("rxb-apply-form");
    if (!form) return false;
    if (!form.checkValidity()) { form.reportValidity(); return false; }

    const clayUrl = form.dataset.clayUrl || "";

    // If Clay URL is configured, send the user there with the data prefilled where possible
    if (clayUrl) {
      // Open Clay's form (or POST to it). Simplest: redirect with email & business name prefilled.
      const data = new FormData(form);
      const params = new URLSearchParams();
      data.forEach((v, k) => { if (typeof v === "string") params.append(k, v); });
      const sep = clayUrl.includes("?") ? "&" : "?";
      window.location.href = clayUrl + sep + params.toString();
      return false;
    }

    // Fallback, show local thanks panel + email summary
    const data = new FormData(form);
    let body = "Wholesale application from " + (data.get("business_name") || "(no name)") + "\n\n";
    data.forEach((v, k) => { if (typeof v === "string" && v) body += k + ": " + v + "\n"; });
    // Show thanks
    document.getElementById("apply-thanks").style.display = "block";
    form.style.display = "none";
    window.scrollTo({ top: document.getElementById("apply").offsetTop - 80, behavior: "smooth" });
    // Optionally trigger mailto for fallback delivery
    try {
      const subject = encodeURIComponent("Wholesale Application, " + (data.get("business_name") || "Rebel X"));
      const mailto = "mailto:wholesale@rebelxbrands.com?subject=" + subject + "&body=" + encodeURIComponent(body);
      // Open mailto in a hidden way so we don't surprise the user, comment out if undesired
      // window.location.href = mailto;
      console.log("[RebelX] Application submitted (no Clay URL). Mailto fallback prepared:", mailto.slice(0, 100) + "...");
    } catch (err) {}
    return false;
  };

    // ============================================================
  // ORDER BUILDER
  // ============================================================
  const order = {}; // { productId: qty }
  let activeTier = 50; // Tier 1 = ~50% off MSRP (default selection)

  function totalRetail() {
    let sum = 0;
    Object.entries(order).forEach(([id, qty]) => {
      const p = PRODUCTS.find(x => x.id === id);
      if (!p) return;
      // Retail value = MSRP × pack count × qty
      const packCount = p.casePack && /\d/.test(p.casePack) ? parseInt(p.casePack.match(/\d+/)[0]) : 1;
      sum += p.price * packCount * qty;
    });
    return sum;
  }
  function totalCases() {
    return Object.values(order).reduce((a, b) => a + b, 0);
  }
  function wholesaleCost() {
    // v61: tier-based "Your cost" = sum of chosen-tier case price × qty.
    let sum = 0;
    Object.entries(order).forEach(([id, qty]) => { sum += rxTierCase(id, activeTier) * qty; });
    return sum;
  }

  function renderBuilder() {
    const items = Object.entries(order);

    // v61: tier-based totals (chosen Tier1–4 case price), computed up front so the
    // float-cart badge can update even on pages without the full builder drawer.
    let cost = 0;     // "Your cost" = sum of tier case price × qty
    let retail = 0;   // "MSRP (retail) value" = sum of MSRP case value × qty
    items.forEach(([id, qty]) => {
      cost   += rxTierCase(id, activeTier) * qty;
      retail += rxMsrpCase(id) * qty;
    });
    let discount = retail - cost;          // wholesale discount vs MSRP
    if (discount < 0) discount = 0;        // never negative

    // Drawer body — guard: may be absent on non-home pages.
    const body = document.getElementById("builder-body");
    if (body) {
      if (!items.length) {
        body.innerHTML = `<div class="builder-empty">
          <div class="ico">🛒</div>
          <p>No items yet.</p>
          <div class="tip">Click + on any product to add</div>
        </div>`;
      } else {
        body.innerHTML = items.map(([id, qty]) => {
          const p = PRODUCTS.find(x => x.id === id);
          if (!p) return "";
          const linePrice = rxTierCase(id, activeTier) * qty; // chosen tier case price
          return `
            <div class="blitem">
              <div class="thumb">
                <img src="${p.thumbUrl}" alt="" onerror="this.style.display='none';" />
              </div>
              <div class="info">
                <div class="name">${p.title}</div>
                <div class="pack">${p.casePack}</div>
                <div class="price">${fmtMoney(linePrice)} <span style="color:var(--muted);font-weight:500;">your cost</span></div>
              </div>
              <div class="ctrl">
                <div class="qty">
                  <button onclick="RebelX.updateQty('${id}', -1)">−</button>
                  <span class="count">${qty}</span>
                  <button onclick="RebelX.updateQty('${id}', 1)">+</button>
                </div>
                <a class="remove" onclick="RebelX.removeItem('${id}'); event.preventDefault();" href="#">remove</a>
              </div>
            </div>
          `;
        }).join("");
      }
    }

    // Totals — guard each node individually.
    const tRetail = document.getElementById("t-retail");
    if (tRetail) tRetail.textContent = fmtMoney(retail);
    const tDiscount = document.getElementById("t-discount");
    if (tDiscount) tDiscount.textContent = "−" + fmtMoney(discount);
    const tTotal = document.getElementById("t-total");
    if (tTotal) tTotal.textContent = fmtMoney(cost);
    const sav = document.getElementById("t-savings");
    if (sav) {
      if (retail > 0) {
        sav.style.display = "block";
        sav.innerHTML = `You save <strong>${fmtMoney(discount)}</strong> vs. MSRP.`;
      } else {
        sav.style.display = "none";
      }
    }

    // Float cart — badge shows tier-based "Your cost" and total item qty.
    const count = totalCases();
    const cc = document.getElementById("cart-count");
    if (cc) cc.textContent = count;
    const ct = document.getElementById("cart-total");
    if (ct) ct.textContent = fmtMoney(cost);
    const fc = document.getElementById("floatcart");
    if (fc) fc.style.display = count > 0 ? "flex" : "none";
  }

  // ============================================================
  // Wishlist persistence (v21), auto-save/restore via localStorage
  // so adds on the catalog page round-trip to the apply page and back.
  // ============================================================
  function saveWishlistToStorage() {
    try {
      const items = Object.entries(order).map(([id, qty]) => {
        const p = PRODUCTS.find(x => x.id === id);
        if (!p) return null;
        const units = qty * (p.casePackQty || 1);
        return {
          id: p.id,
          handle: p.handle || "",
          name: p.title,
          brand: p.brand || "",
          casePack: p.casePack || "",
          cases: qty,
          units: units,
          unitPrice: p.price || 0
        };
      }).filter(Boolean);
      if (!items.length) {
        localStorage.removeItem("rxbWishlist");
        return;
      }
      const payload = {
        items: items,
        tier: activeTier,
        retailValue: totalRetail(),
        estimatedCost: wholesaleCost(),
        updated: new Date().toISOString()
      };
      localStorage.setItem("rxbWishlist", JSON.stringify(payload));
    } catch (e) { /* ignore */ }
  }
  function loadWishlistFromStorage() {
    try {
      const raw = localStorage.getItem("rxbWishlist");
      if (!raw) return;
      const data = JSON.parse(raw);
      if (!data || !data.items || !data.items.length) return;
      let restored = 0;
      data.items.forEach(it => {
        if (PRODUCTS.find(x => x.id === it.id)) {
          order[it.id] = Math.max(1, it.cases || 1);
          restored++;
        }
      });
      if (data.tier && [50, 58, 65, 67].indexOf(data.tier) !== -1) {
        activeTier = data.tier;
        document.querySelectorAll(".tier-toggle button").forEach(b => {
          b.classList.toggle("active", parseInt(b.dataset.tier) === activeTier);
        });
      }
      if (restored > 0) renderBuilder();
    } catch (e) { /* ignore */ }
  }

  window.RebelX = window.RebelX || {};
  // v61: expose renderBuilder so the all-pages floatcart IIFE can delegate to the
  // canonical tier-based renderer instead of running conflicting per-unit math.
  window.RebelX.renderBuilder = renderBuilder;
  // Re-hydrate `order` from localStorage (e.g. on cross-tab storage events) then render.
  window.RebelX.reloadFromStorage = function() {
    try {
      Object.keys(order).forEach(function(k){ delete order[k]; });
      loadWishlistFromStorage();
    } catch (e) {}
    renderBuilder();
  };
  window.RebelX.addToOrder = function(id) {
    order[id] = (order[id] || 0) + 1;
    renderBuilder();
    saveWishlistToStorage();
    // Open the panel briefly so the user sees it land (guard: drawer may be absent
    // on product/section pages — v61).
    const b = document.getElementById("builder");
    const ov = document.getElementById("builder-overlay");
    if (b && !b.classList.contains("open")) {
      b.classList.add("open");
      if (ov) ov.classList.add("open");
    }
  };
  window.RebelX.updateQty = function(id, delta) {
    order[id] = Math.max(0, (order[id] || 0) + delta);
    if (order[id] === 0) delete order[id];
    renderBuilder();
    saveWishlistToStorage();
  };
  window.RebelX.removeItem = function(id) {
    delete order[id];
    renderBuilder();
    saveWishlistToStorage();
  };

  function wireBuilderControls() { /* v60CA: named + re-callable; guards so a missing element can't throw on customizer re-render */
  // Float cart toggle — v61: guard each node (these elements only exist where the
  // builder drawer is rendered; unguarded getElementById(...).addEventListener
  // previously threw and aborted the rest of the script on other pages).
  var _fcEl = document.getElementById("floatcart");
  if (_fcEl) _fcEl.addEventListener("click", () => {
    var b = document.getElementById("builder");
    var ov = document.getElementById("builder-overlay");
    if (b) b.classList.add("open");
    if (ov) ov.classList.add("open");
  });
  var _bcEl = document.getElementById("builder-close");
  if (_bcEl) _bcEl.addEventListener("click", () => {
    var b = document.getElementById("builder");
    var ov = document.getElementById("builder-overlay");
    if (b) b.classList.remove("open");
    if (ov) ov.classList.remove("open");
  });
  var _boEl = document.getElementById("builder-overlay");
  if (_boEl) _boEl.addEventListener("click", () => {
    var b = document.getElementById("builder");
    var ov = document.getElementById("builder-overlay");
    if (b) b.classList.remove("open");
    if (ov) ov.classList.remove("open");
  });

  // Tier toggle
  document.querySelectorAll(".tier-toggle button").forEach(b => {
    b.addEventListener("click", () => {
      document.querySelectorAll(".tier-toggle button").forEach(x => x.classList.remove("active"));
      b.classList.add("active");
      activeTier = parseInt(b.dataset.tier);
      renderBuilder();
      saveWishlistToStorage();
    });
  });

  // Continue to Application → save wishlist to localStorage then route to apply page
  var _checkoutEl = document.getElementById("builder-checkout");
  if (_checkoutEl) _checkoutEl.addEventListener("click", () => {
    const items = Object.entries(order)
      .map(([id, qty]) => {
        const p = PRODUCTS.find(x => x.id === id);
        if (!p) return null;
        const units = qty * (p.casePackQty || 1);
        return {
          id: p.id,
          handle: p.handle || "",
          name: p.title,
          brand: p.brand || "",
          casePack: p.casePack || "",
          cases: qty,
          units: units,
          unitPrice: p.price || 0
        };
      })
      .filter(Boolean);
    const btn = document.getElementById("builder-checkout");
    const status = document.getElementById("builder-cart-status");
    if (!items.length) {
      status.style.display = "block";
      status.style.color = "var(--muted)";
      status.textContent = "Add at least one product to continue.";
      setTimeout(() => { status.style.display = "none"; }, 2400);
      return;
    }
    btn.disabled = true;
    btn.innerHTML = "Saving wishlist…";
    status.style.display = "block";
    status.style.color = "var(--muted)";
    status.textContent = "Saving " + items.length + " item" + (items.length !== 1 ? "s" : "") + " to your wishlist…";
    try {
      const payload = {
        items: items,
        tier: activeTier,
        retailValue: totalRetail(),
        estimatedCost: wholesaleCost(),
        updated: new Date().toISOString()
      };
      localStorage.setItem("rxbWishlist", JSON.stringify(payload));
      status.textContent = "Wishlist saved. Continuing to application…";
      setTimeout(() => { window.location.href = "/pages/apply-for-wholesale"; }, 350);
    } catch (err) {
      console.error("Wishlist save failed:", err);
      btn.disabled = false;
      btn.innerHTML = "Continue to application →";
      status.style.color = "#c0392b";
      status.textContent = "Couldn't save wishlist: " + (err.message || "unknown error");
    }
  });
  } /* v60CA: end wireBuilderControls */
  wireBuilderControls(); /* v60CA: preserve original initial-load behavior */

  // (builder-submit handler removed in v12, single CTA flow now)

  // ============================================================
  // MARGIN CHART (Chart.js)
  // ============================================================
  function renderMarginChart() {
    if (typeof Chart === "undefined") { if ((renderMarginChart._tries = (renderMarginChart._tries || 0) + 1) <= 60) { window.setTimeout(renderMarginChart, 100); } return; }
    const ctx = document.getElementById("marginChart");
    if (!ctx) return;
    // King K Gold scenario: 15-pack, $20 MSRP unit = $300 retail
    // Discount tiers: 40, 50, 60
    const retail = 300;
    const tiers = [
      { name: "Starter", off: 40 },
      { name: "Growth", off: 50 },
      { name: "Distributor", off: 60 }
    ];
    if (window.Chart && Chart.getChart && Chart.getChart(ctx)) { Chart.getChart(ctx).destroy(); }
    new Chart(ctx, {
      type: "bar",
      data: {
        labels: tiers.map(t => t.name),
        datasets: [
          {
            label: "Your cost",
            data: tiers.map(t => Math.round(retail * (1 - t.off / 100))),
            backgroundColor: "#C7BFAC",
            borderRadius: 4,
            barPercentage: 0.55,
            stack: "a"
          },
          {
            label: "Profit per case",
            data: tiers.map(t => Math.round(retail * t.off / 100)),
            backgroundColor: "#F8B60F",
            borderRadius: 4,
            barPercentage: 0.55,
            stack: "a"
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          x: { stacked: true, ticks: { color: "#BBB28E", font: { weight: 700 } }, grid: { display: false } },
          y: {
            stacked: true,
            ticks: { color: "#8A8472", callback: v => "$" + v },
            grid: { color: "rgba(255,255,255,0.06)" }
          }
        },
        plugins: {
          legend: {
            position: "bottom",
            labels: { color: "#C7BFAC", font: { size: 11, weight: 600 }, boxWidth: 12, boxHeight: 12, padding: 12 }
          },
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.dataset.label}: $${ctx.parsed.y}`
            }
          }
        }
      }
    });
  }

  // ============================================================
  // PRODUCT DETAIL MODAL
  // Opens lightbox with full description, flavors, pricing, link to product page
  // ============================================================
  window.RebelX = window.RebelX || {};

  // v49: Always-modal entrypoint used by hero featured-product cards.
  window.RebelX.openQuickView = function(id) {
    const p = PRODUCTS.find(x => x.id === id);
    if (!p) return;
    const overlay = document.getElementById("pd-overlay");
    const modal = document.getElementById("pd-modal");
    if (!overlay || !modal) return;
    _renderDetailIntoModal(p, overlay, modal);
  };

  function _renderDetailIntoModal(p, overlay, modal) {
    document.getElementById("pd-img").src = p.imageUrl;
    document.getElementById("pd-img").alt = p.title;
    document.getElementById("pd-title").textContent = p.title;
    document.getElementById("pd-typeline").textContent = `${p.productType} · MSRP $${p.price}`;
    document.getElementById("pd-vendor").textContent = p.vendor;
    const badge = pickBadge(p.tags || []);
    document.getElementById("pd-badge").innerHTML = badge;
    const fallbackDesc = `${p.title} from ${p.vendor}. ${p.productType} sold in ${p.casePack || "standard"} case packs. Lab-tested with COAs available per batch.`;
    document.getElementById("pd-desc").textContent = p.description || fallbackDesc;

    const attrs = document.getElementById("pd-attrs");
    let attrsHtml = "";
    if (p.dosage)      attrsHtml += `<dt>Dosage</dt><dd>${p.dosage}</dd>`;
    if (p.flavors && p.flavors.length) {
      attrsHtml += `<dt>${p.flavors.length > 1 ? "Flavors" : "Flavor"}</dt><dd>${p.flavors.join(" · ")}</dd>`;
    }
    if (p.casePack)    attrsHtml += `<dt>Case pack</dt><dd>${p.casePack}</dd>`;
    if (p.tags && p.tags.length) {
      attrsHtml += `<dt>Tags</dt><dd>${p.tags.slice(0, 4).join(" · ")}</dd>`;
    }
    attrs.innerHTML = attrsHtml;

    const prices = document.getElementById("pd-prices");
    const unitCount = p.casePack && /\d/.test(p.casePack) ? parseInt(p.casePack.match(/\d+/)[0]) : 1;
    const perUnit = p.casePrice && unitCount ? (p.casePrice / unitCount).toFixed(2) : null;
    let pricesHtml = `
      <div class="row"><span class="lbl">Retail MSRP / unit</span><span class="v">$${p.price.toFixed(2)}</span></div>
    `;
    if (p.casePrice) {
      pricesHtml += `
        <div class="row case">
          <span class="lbl">Wholesale ${p.casePack || "case"}</span>
          <span class="v">$${p.casePrice}<small>$${perUnit}/unit</small></span>
        </div>
      `;
    }
    pricesHtml += `<div class="row" style="padding-top:6px;"><span class="lbl">Sample / split</span><span style="font-size:11px;color:var(--muted);">Available on approval</span></div>`;
    prices.innerHTML = pricesHtml;

    const addBtn = document.getElementById("pd-add");
    addBtn.onclick = function() { RebelX.addToOrder(p.id); RebelX.closeDetail(); };
    const fullPage = document.getElementById("pd-fullpage");
    const shopifyUrl = (typeof rxProductPageUrl === "function") ? rxProductPageUrl(p.id) : null;
    if (shopifyUrl) {
      fullPage.href = shopifyUrl;
      fullPage.textContent = "View full product page ↗";
      fullPage.target = "_self";
      fullPage.style.display = "";
    } else if (p.productUrl) {
      fullPage.href = p.productUrl;
      fullPage.style.display = "";
    } else {
      fullPage.href = "#apply";
      fullPage.textContent = "Request more info ↗";
      fullPage.target = "_self";
    }

    overlay.classList.add("open");
    modal.classList.add("open");
    overlay.setAttribute("aria-hidden", "false");
    modal.removeAttribute("inert");
    modal.removeAttribute("aria-hidden");
    document.body.style.overflow = "hidden";
  }

  window.RebelX.openDetail = function(id) {
    // v46: short-circuit to the real product page when we have a Shopify handle for this id.
    const directUrl = (typeof rxProductPageUrl === "function") ? rxProductPageUrl(id) : null;
    if (directUrl) { window.location.href = directUrl; return; }

    const p = PRODUCTS.find(x => x.id === id);
    if (!p) return;
    const overlay = document.getElementById("pd-overlay");
    const modal = document.getElementById("pd-modal");
    if (!overlay || !modal) return;

    // Image
    document.getElementById("pd-img").src = p.imageUrl;
    document.getElementById("pd-img").alt = p.title;

    // Title, type, vendor
    document.getElementById("pd-title").textContent = p.title;
    document.getElementById("pd-typeline").textContent = `${p.productType} · MSRP $${p.price}`;
    document.getElementById("pd-vendor").textContent = p.vendor;

    // Badge (best seller / new / etc.)
    const badge = pickBadge(p.tags || []);
    document.getElementById("pd-badge").innerHTML = badge;

    // Description
    const fallbackDesc = `${p.title} from ${p.vendor}. ${p.productType} sold in ${p.casePack || "standard"} case packs. Lab-tested with COAs available per batch.`;
    document.getElementById("pd-desc").textContent = p.description || fallbackDesc;

    // Attributes (dosage, flavors, etc.)
    const attrs = document.getElementById("pd-attrs");
    let attrsHtml = "";
    if (p.dosage)      attrsHtml += `<dt>Dosage</dt><dd>${p.dosage}</dd>`;
    if (p.flavors && p.flavors.length) {
      attrsHtml += `<dt>${p.flavors.length > 1 ? "Flavors" : "Flavor"}</dt><dd>${p.flavors.join(" · ")}</dd>`;
    }
    if (p.casePack)    attrsHtml += `<dt>Case pack</dt><dd>${p.casePack}</dd>`;
    if (p.tags && p.tags.length) {
      attrsHtml += `<dt>Tags</dt><dd>${p.tags.slice(0, 4).join(" · ")}</dd>`;
    }
    attrs.innerHTML = attrsHtml;

    // Pricing block
    const prices = document.getElementById("pd-prices");
    const unitCount = p.casePack && /\d/.test(p.casePack) ? parseInt(p.casePack.match(/\d+/)[0]) : 1;
    const perUnit = p.casePrice && unitCount ? (p.casePrice / unitCount).toFixed(2) : null;
    let pricesHtml = `
      <div class="row"><span class="lbl">Retail MSRP / unit</span><span class="v">$${p.price.toFixed(2)}</span></div>
    `;
    if (p.casePrice) {
      pricesHtml += `
        <div class="row case">
          <span class="lbl">Wholesale ${p.casePack || "case"}</span>
          <span class="v">$${p.casePrice}<small>$${perUnit}/unit</small></span>
        </div>
      `;
    }
    pricesHtml += `<div class="row" style="padding-top:6px;"><span class="lbl">Sample / split</span><span style="font-size:11px;color:var(--muted);">Available on approval</span></div>`;
    prices.innerHTML = pricesHtml;

    // Actions
    const addBtn = document.getElementById("pd-add");
    addBtn.onclick = function() { RebelX.addToOrder(id); RebelX.closeDetail(); };
    const fullPage = document.getElementById("pd-fullpage");
    if (p.productUrl) {
      fullPage.href = p.productUrl;
      fullPage.style.display = "";
    } else {
      // No external page, link to apply/contact instead
      fullPage.href = "#apply";
      fullPage.textContent = "Request more info ↗";
      fullPage.target = "_self";
    }

    overlay.classList.add("open");
    modal.classList.add("open");
    overlay.setAttribute("aria-hidden", "false");
    modal.removeAttribute("inert");
    modal.removeAttribute("aria-hidden");
    document.body.style.overflow = "hidden";
  };

  window.RebelX.closeDetail = function() {
    const overlay = document.getElementById("pd-overlay");
    const modal = document.getElementById("pd-modal");
    if (!overlay || !modal) return;
    overlay.classList.remove("open");
    modal.classList.remove("open");
    overlay.setAttribute("aria-hidden", "true");
    modal.setAttribute("inert", "");
    modal.removeAttribute("aria-hidden");
    document.body.style.overflow = "";
  };

  function initProductDetail() {
    if (window._rxbDetailWired) return; window._rxbDetailWired = true; /* v60CA */
    const overlay = document.getElementById("pd-overlay");
    const closeBtn = document.getElementById("pd-close");
    if (overlay) overlay.addEventListener("click", () => RebelX.closeDetail());
    if (closeBtn) closeBtn.addEventListener("click", () => RebelX.closeDetail());
    document.addEventListener("keydown", e => {
      if (e.key === "Escape") RebelX.closeDetail();
    });
  }

  // ============================================================
  // SCROLL REVEAL · IntersectionObserver
  // ============================================================
  function initReveal() {
    const sel = ".reveal, .reveal-stagger, .reveal-left, .reveal-right, .reveal-scale";
    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll(sel).forEach(el => el.classList.add("in"));
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });

    document.querySelectorAll(sel).forEach(el => obs.observe(el));
  }

  // ============================================================
  // MOBILE MENU TOGGLE
  // ============================================================
  function initMobileMenu() {
    if (window._rxbMenuWired) return; window._rxbMenuWired = true; /* v60CA */
    const btn = document.getElementById("nav-toggle");
    const menu = document.getElementById("mobile-menu");
    if (!btn || !menu) return;

    // v60BJ: Do NOT bind a competing click handler on #nav-toggle here.
    // The button already toggles via its inline onclick + the _rxButtonFallbacks
    // listener, both routed through the de-duped window._rxToggleMobileMenu.
    // Binding a second open()/close() here (homepage-only, since init() aborts
    // off-home) double-toggled and was the reason behaviour differed by template.
    // Use the shared global close helper for link/Escape so the inline transform
    // is reset consistently.
    const close = (window._rxCloseMobileMenu) ? window._rxCloseMobileMenu : function () {
      document.body.classList.remove("menu-open");
      btn.setAttribute("aria-expanded", "false");
      menu.setAttribute("inert", "");
      menu.removeAttribute("aria-hidden");
    };
    menu.querySelectorAll("a").forEach(a => a.addEventListener("click", close));
    document.addEventListener("keydown", e => { if (e.key === "Escape") close(); });
  }

  // ============================================================
  // SCROLL PROGRESS BAR
  // ============================================================
  function initScrollProgress() {
    if (window._rxbScrollWired) return; window._rxbScrollWired = true; /* v60CA */
    const bar = document.getElementById("scroll-bar");
    if (!bar) return;
    let ticking = false;
    function update() {
      const scrolled = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      const total = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const pct = total > 0 ? Math.min(100, Math.max(0, (scrolled / total) * 100)) : 0;
      bar.style.width = pct + "%";
      ticking = false;
    }
    window.addEventListener("scroll", () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // ============================================================
  // PARALLAX on .parallax elements (driven by scrollY)
  // ============================================================
  function initParallax() {
    if (window._rxbParallaxWired) return; window._rxbParallaxWired = true; /* v60CA */
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    // Skip parallax entirely on small screens, .deco elements are display:none anyway
    if (window.matchMedia("(max-width: 640px)").matches) return;
    const els = Array.from(document.querySelectorAll(".parallax"));
    if (!els.length) return;
    let raf = false;
    function update() {
      const y = window.scrollY || window.pageYOffset || 0;
      els.forEach(el => {
        const speed = parseFloat(el.dataset.speed || "0.15");
        el.style.transform = `translateY(${(y * speed * -1).toFixed(1)}px)`;
      });
      raf = false;
    }
    window.addEventListener("scroll", () => {
      if (!raf) { requestAnimationFrame(update); raf = true; }
    }, { passive: true });
  }

  // ============================================================
  // MOBILE CAROUSEL ACTIVE-CARD DETECTION
  // Highlights the carousel card closest to viewport center as user swipes
  // ============================================================
  function initCarouselActive() {
    if (!window.matchMedia("(max-width: 640px)").matches) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const carousels = document.querySelectorAll(
      ".programs-grid, .how-steps, .brands-grid, .why-grid, .tier-grid, .testi-grid, .hero-visual"
    );

    carousels.forEach(carousel => {
      const items = Array.from(carousel.children).filter(c => c.offsetWidth > 0);
      if (items.length < 2) return;

      let raf = false;
      function update() {
        const cRect = carousel.getBoundingClientRect();
        const center = cRect.left + cRect.width / 2;
        let closest = null;
        let minDist = Infinity;
        items.forEach(item => {
          const r = item.getBoundingClientRect();
          const itemCenter = r.left + r.width / 2;
          const dist = Math.abs(itemCenter - center);
          if (dist < minDist) { minDist = dist; closest = item; }
        });
        items.forEach(item => {
          item.classList.toggle("carousel-active", item === closest);
        });
        raf = false;
      }

      carousel.addEventListener("scroll", () => {
        if (!raf) { requestAnimationFrame(update); raf = true; }
      }, { passive: true });

      // Run once initially after layout settles
      setTimeout(update, 200);
    });
  }

  // ============================================================
  // ANIMATED NUMBER COUNTERS · hero stats
  // ============================================================
  function initCounters() {
    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll(".counter").forEach(el => {
        el.textContent = (el.dataset.target || "0") + (el.dataset.suffix || "");
      });
      return;
    }
    const counterObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        const el = e.target;
        const target = parseInt(el.dataset.target || "0", 10);
        const suffix = el.dataset.suffix || "";
        const duration = 1400;
        const start = performance.now();
        const startVal = 0;
        function tick(now) {
          const t = Math.min(1, (now - start) / duration);
          // ease-out cubic
          const eased = 1 - Math.pow(1 - t, 3);
          const v = Math.round(startVal + (target - startVal) * eased);
          el.textContent = v + suffix;
          if (t < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        counterObs.unobserve(el);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll(".counter").forEach(el => counterObs.observe(el));
  }

  // ============================================================
  // INIT
  // ============================================================
  (async function init() {
    // v62: hydrate the wishlist FIRST, before any homepage-only render, so the
    // badge/drawer reflect localStorage on EVERY template even if a later
    // homepage-only render throws.
    try { loadWishlistFromStorage(); } catch (e) { console.warn("Rebel X: wishlist load failed", e); }
    try { renderBuilder(); } catch (e) { console.warn("Rebel X: renderBuilder failed", e); }
    // Homepage-only renders/setup — each is null-guarded internally, but wrap in
    // try/catch as belt-and-suspenders so a throw can never abort init().
    try { renderHero(); } catch (e) { console.warn("Rebel X: renderHero failed", e); }
    try { renderProducts(); } catch (e) { console.warn("Rebel X: renderProducts failed", e); }
    try { renderMarginChart(); } catch (e) { console.warn("Rebel X: renderMarginChart failed", e); }
    try { initReveal(); } catch (e) { console.warn("Rebel X: initReveal failed", e); }
    try { initCounters(); } catch (e) { console.warn("Rebel X: initCounters failed", e); }
    try { initMobileMenu(); } catch (e) { console.warn("Rebel X: initMobileMenu failed", e); }
    try { initScrollProgress(); } catch (e) { console.warn("Rebel X: initScrollProgress failed", e); }
    try { initParallax(); } catch (e) { console.warn("Rebel X: initParallax failed", e); }
    try { initCarouselActive(); } catch (e) { console.warn("Rebel X: initCarouselActive failed", e); }
    try { initProductDetail(); } catch (e) { console.warn("Rebel X: initProductDetail failed", e); }

    // Detect image availability if blocked by sandbox, show SVG fallbacks
    try {
      const imagesOK = await detectImages();
      if (!imagesOK) {
        document.body.classList.add("no-photos");
        console.info("Rebel X: external images blocked, using SVG silhouettes");
      }
    } catch (e) { /* non-fatal */ }
  })();

  /* v60CA: re-hydrate sections re-rendered by the theme customizer */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    var rx = function (label, fn) { try { fn(); } catch (err) { console.warn('Rebel X: ' + label + ' (section:load) skipped:', err && err.message); } };
    if (!root || !root.querySelector) return;
    if (root.querySelector('#hero-visual')) rx('renderHero', renderHero);
    if (root.querySelector('#product-grid')) { rx('renderProducts', renderProducts); rx('wireCatalogChips', wireCatalogChips); }
    if (root.querySelector('#builder-body') || root.querySelector('#floatcart')) { rx('renderBuilder', renderBuilder); rx('wireBuilderControls', wireBuilderControls); }
    if (root.querySelector('#marginChart')) rx('renderMarginChart', renderMarginChart);
    rx('initReveal', initReveal);
    rx('initCounters', initCounters);
    rx('initCarouselActive', initCarouselActive);
    /* v60CD: re-bind search overlay open/close after header section re-render (attach() is idempotent via dataset.rxBound) */
    if (root.querySelector('#nav-search-btn') || root.querySelector('.rxs-search-close')) {
      try { if (window._rxButtonFallbacks && window._rxButtonFallbacks.attach) window._rxButtonFallbacks.attach(); } catch (err) { console.warn('Rebel X: search re-bind (section:load) skipped:', err && err.message); }
    }
  });

  // ============================================================
  // Apply-page wishlist hydration (v19)
  // ============================================================
  (function hydrateApplyWishlist() {
    const panel = document.getElementById("rxb-wishlist-panel");
    if (!panel) return;
    let raw = null;
    try { raw = localStorage.getItem("rxbWishlist"); } catch (e) {}
    if (!raw) return;
    let data;
    try { data = JSON.parse(raw); } catch (e) { return; }
    if (!data || !data.items || !data.items.length) return;

    const fmt = n => "$" + Math.round(n).toLocaleString("en-US");
    const esc = s => String(s).replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"}[c]));

    const totalCases = data.items.reduce((s, it) => s + (it.cases || 0), 0);
    const totalUnits = data.items.reduce((s, it) => s + (it.units || 0), 0);
    const tierLabel = data.tier ? data.tier + "% tier (est.)" : "Tier TBD";

    const itemsHtml = data.items.map(it => (
      '<li class="rxb-wl-item">' +
        '<div>' +
          '<div class="rxb-wl-name">' + esc(it.name) + '</div>' +
          '<div class="rxb-wl-sub">' + esc(it.brand || "") + ' · ' + esc(it.casePack || "") + '</div>' +
        '</div>' +
        '<div class="rxb-wl-qty">' + (it.cases || 0) + ' case' + ((it.cases || 0) === 1 ? '' : 's') + '</div>' +
      '</li>'
    )).join("");

    panel.className = "";
    panel.innerHTML =
      '<div class="rxb-wl-head">' +
        '<p class="rxb-wl-title">★ Your interested products</p>' +
        '<span class="rxb-wl-meta">' + data.items.length + ' product' + (data.items.length === 1 ? '' : 's') + ' · ' + totalCases + ' case' + (totalCases === 1 ? '' : 's') + ' · ' + totalUnits + ' units</span>' +
      '</div>' +
      '<ul class="rxb-wl-list">' + itemsHtml + '</ul>' +
      '<div class="rxb-wl-foot">' +
        '<div class="rxb-wl-est">' + tierLabel + ' · est. <strong>' + fmt(data.estimatedCost || 0) + '</strong></div>' +
        '<div class="rxb-wl-actions">' +
          '<button type="button" class="rxb-wl-btn primary" id="rxb-wl-copy">Copy list as text</button>' +
          '<a href="/" class="rxb-wl-btn">Edit list</a>' +
        '</div>' +
      '</div>';

    const copyBtn = document.getElementById("rxb-wl-copy");
    if (copyBtn) {
      copyBtn.addEventListener("click", () => {
        const text = "Wholesale Wishlist:\n" + data.items.map(it =>
          "  • " + it.cases + "× " + it.name + " (" + (it.casePack || "case") + ")"
        ).join("\n") + "\n\nTotal: " + totalCases + " cases / " + totalUnits + " units\nEstimated at " + (data.tier || "?") + "% tier: " + fmt(data.estimatedCost || 0);
        try {
          navigator.clipboard.writeText(text);
          panel.classList.add("copied");
          const orig = copyBtn.textContent;
          copyBtn.textContent = "✓ Copied, paste into the form";
          setTimeout(() => { panel.classList.remove("copied"); copyBtn.textContent = orig; }, 2800);
        } catch (e) {
          window.prompt("Copy this and paste into the form's notes field:", text);
        }
      });
    }
  })();

  // ============================================================
  // Product page (v25) — variant select, thumbnail switching, wishlist add
  // ============================================================
  (function initProductPage() {
    const main = document.querySelector(".rx-prod-img-main img");
    const thumbs = document.querySelectorAll(".rx-prod-thumb");
    const variantBtns = document.querySelectorAll(".rx-prod-variant");
    const addBtn = document.getElementById("rx-prod-add");
    const status = document.getElementById("rx-prod-add-status");
    if (!addBtn) return;

    // Thumbnail switching - v52: clear srcset so the new src actually renders
    thumbs.forEach(t => {
      t.addEventListener("click", () => {
        thumbs.forEach(x => x.classList.remove("active"));
        t.classList.add("active");
        if (main) {
          const newSrc = t.getAttribute("data-img");
          main.removeAttribute("srcset");
          main.removeAttribute("sizes");
          main.src = newSrc;
          // Also update the data-src-large so the zoom modal opens this image
          const largeAttr = t.getAttribute("data-img-large");
          if (largeAttr) main.setAttribute("data-src-large", largeAttr);
          else main.setAttribute("data-src-large", newSrc);
        }
      });
    });

    // Variant selection
    let selectedVariant = null;
    if (variantBtns.length) {
      selectedVariant = {
        id: variantBtns[0].getAttribute("data-variant-id"),
        title: variantBtns[0].getAttribute("data-variant-title"),
        price: parseFloat(variantBtns[0].getAttribute("data-variant-price") || "0")
      };
      variantBtns.forEach(b => {
        b.addEventListener("click", () => {
          variantBtns.forEach(x => x.setAttribute("aria-pressed", "false"));
          b.setAttribute("aria-pressed", "true");
          selectedVariant = {
            id: b.getAttribute("data-variant-id"),
            title: b.getAttribute("data-variant-title"),
            price: parseFloat(b.getAttribute("data-variant-price") || "0")
          };
        });
      });
    }

    // v61: resolve the product-page button to a PRODUCTS string id so the add goes
    // through the SAME path as the catalog (RebelX.addToOrder → in-memory `order`
    // + the SAME rxbWishlist localStorage payload). ONE source of truth.
    function resolveProductsId() {
      // 1) explicit data-product-id matching a PRODUCTS id
      var pid = addBtn.getAttribute("data-product-id");
      if (pid && PRODUCTS.find(function(x){ return x.id === pid; })) return pid;
      // 2) data-handle matches a PRODUCTS id directly (ids are handles)
      var handle = addBtn.getAttribute("data-handle");
      if (handle && PRODUCTS.find(function(x){ return x.id === handle; })) return handle;
      // 3) variantId match
      var firstVarId = selectedVariant ? selectedVariant.id : addBtn.getAttribute("data-variant-id");
      if (firstVarId) {
        var pv = PRODUCTS.find(function(x){ return String(x.variantId) === String(firstVarId); });
        if (pv) return pv.id;
      }
      return null;
    }

    // Add to wishlist — unified with the catalog add path.
    addBtn.addEventListener("click", () => {
      try {
        var resolvedId = resolveProductsId();
        if (resolvedId && window.RebelX && typeof window.RebelX.addToOrder === "function") {
          // SAME mechanism as catalog: writes the in-memory `order` map +
          // the SAME rxbWishlist payload (with tier-based pricing) via saveWishlistToStorage.
          window.RebelX.addToOrder(resolvedId);
          if (status) {
            status.style.display = "block";
            status.classList.remove("error");
            var n = Object.keys(order).length;
            status.textContent = "✓ Added to wishlist · " + n + " product" + (n === 1 ? "" : "s") + " saved";
          }
          return;
        }
        // Fallback (no PRODUCTS match): write a minimal rxbWishlist entry so the
        // user isn't blocked. Kept compatible with the shared payload shape.
        const title = addBtn.getAttribute("data-title");
        const handle = addBtn.getAttribute("data-handle");
        const brand = addBtn.getAttribute("data-brand");
        const price = parseFloat(addBtn.getAttribute("data-price") || "0");
        const image = addBtn.getAttribute("data-image");
        let payload;
        const raw = localStorage.getItem("rxbWishlist");
        if (raw) { try { payload = JSON.parse(raw); } catch (e) { payload = null; } }
        if (!payload || !payload.items) {
          payload = { items: [], tier: 50, retailValue: 0, estimatedCost: 0, updated: new Date().toISOString() };
        }
        const itemKey = handle || title;
        const existing = payload.items.find(it => it.id === itemKey);
        const variantTitle = selectedVariant ? selectedVariant.title : "Single unit";
        const unitPrice = selectedVariant ? selectedVariant.price : price;
        if (existing) {
          existing.cases = (existing.cases || 0) + 1;
          existing.units = existing.cases;
          existing.casePack = variantTitle;
          existing.unitPrice = unitPrice;
        } else {
          payload.items.push({ id: itemKey, handle: handle, name: title, brand: brand, casePack: variantTitle, cases: 1, units: 1, unitPrice: unitPrice, image: image });
        }
        payload.updated = new Date().toISOString();
        localStorage.setItem("rxbWishlist", JSON.stringify(payload));
        if (window.RebelX && window.RebelX.refreshFloatcart) window.RebelX.refreshFloatcart();
        if (status) {
          status.style.display = "block";
          status.classList.remove("error");
          status.textContent = "✓ Added to wishlist · " + payload.items.length + " product" + (payload.items.length === 1 ? "" : "s") + " saved";
        }
      } catch (err) {
        if (status) {
          status.style.display = "block";
          status.classList.add("error");
          status.textContent = "Couldn't save: " + (err.message || "unknown error");
        }
      }
    });
  
  // ============================================================
  // v48: PRODUCT IMAGE ZOOM LIGHTBOX
  // ============================================================
  function initProductZoom() {
    const modal = document.getElementById("rx-zoom-modal");
    const main  = document.getElementById("rx-prod-img-main");
    if (!modal || !main) return;

    const mainImg = document.getElementById("rx-prod-img-main-img");
    const zoomImg = document.getElementById("rx-zoom-img");
    const stage   = document.getElementById("rx-zoom-stage");
    const closeBtn= document.getElementById("rx-zoom-close");
    const miniBtn = document.getElementById("rx-prod-zoom-open");
    const inBtn   = document.getElementById("rx-zoom-in");
    const outBtn  = document.getElementById("rx-zoom-out");
    const resetBtn= document.getElementById("rx-zoom-reset");
    const pctLbl  = document.getElementById("rx-zoom-pct");

    let scale = 1;
    let tx = 0, ty = 0;
    const MIN = 1, MAX = 5;

    function applyTransform() {
      zoomImg.style.transform = `translate(${tx}px, ${ty}px) scale(${scale})`;
      pctLbl.textContent = Math.round(scale * 100) + "%";
      zoomImg.classList.toggle("zoomable", scale > 1.001);
    }
    function reset() { scale = 1; tx = 0; ty = 0; applyTransform(); }
    function setScale(next, anchorX, anchorY) {
      next = Math.max(MIN, Math.min(MAX, next));
      if (anchorX != null && anchorY != null) {
        const rect = zoomImg.getBoundingClientRect();
        const dx = anchorX - (rect.left + rect.width / 2);
        const dy = anchorY - (rect.top + rect.height / 2);
        const ratio = next / scale;
        tx -= dx * (ratio - 1);
        ty -= dy * (ratio - 1);
      }
      scale = next;
      if (scale <= MIN + 0.001) { tx = 0; ty = 0; }
      applyTransform();
    }
    function open() {
      const large = mainImg.getAttribute("data-src-large") || mainImg.src;
      zoomImg.src = large;
      zoomImg.alt = mainImg.alt || "";
      modal.removeAttribute("hidden");
      modal.classList.add("open");
      document.body.style.overflow = "hidden";
      reset();
    }
    function close() {
      modal.classList.remove("open");
      modal.setAttribute("hidden", "");
      document.body.style.overflow = "";
    }

    // Open triggers
    main.addEventListener("click", function(e) {
      // Don't open if user clicked a thumb button (none here) or badge area
      if (e.target.closest(".rx-prod-zoom-mini")) return;
      open();
    });
    main.addEventListener("keydown", function(e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); }
    });
    if (miniBtn) miniBtn.addEventListener("click", function(e) { e.stopPropagation(); open(); });

    // Close triggers
    closeBtn.addEventListener("click", close);
    modal.addEventListener("click", function(e) {
      // Click outside the image closes
      if (e.target === modal || e.target === stage) close();
    });
    document.addEventListener("keydown", function(e) {
      if (modal.classList.contains("open") && e.key === "Escape") close();
    });

    // Zoom buttons
    inBtn.addEventListener("click", function() { setScale(scale * 1.25); });
    outBtn.addEventListener("click", function() { setScale(scale / 1.25); });
    resetBtn.addEventListener("click", reset);

    // Wheel zoom inside the modal
    stage.addEventListener("wheel", function(e) {
      e.preventDefault();
      const factor = e.deltaY < 0 ? 1.12 : 1 / 1.12;
      setScale(scale * factor, e.clientX, e.clientY);
    }, { passive: false });

    // Double-click toggle
    stage.addEventListener("dblclick", function(e) {
      if (scale > 1.001) reset();
      else setScale(2, e.clientX, e.clientY);
    });

    // Drag-to-pan when zoomed
    let dragging = false, dragX = 0, dragY = 0, startTx = 0, startTy = 0;
    function startDrag(x, y) {
      if (scale <= 1.001) return;
      dragging = true; dragX = x; dragY = y; startTx = tx; startTy = ty;
      zoomImg.classList.add("dragging");
    }
    function moveDrag(x, y) {
      if (!dragging) return;
      tx = startTx + (x - dragX);
      ty = startTy + (y - dragY);
      applyTransform();
    }
    function endDrag() {
      dragging = false;
      zoomImg.classList.remove("dragging");
    }
    zoomImg.addEventListener("mousedown", function(e) { e.preventDefault(); startDrag(e.clientX, e.clientY); });
    window.addEventListener("mousemove", function(e) { if (dragging) { e.preventDefault(); moveDrag(e.clientX, e.clientY); } });
    window.addEventListener("mouseup", endDrag);

    // Pinch-to-zoom + drag on touch
    let pinchStartDist = 0, pinchStartScale = 1;
    stage.addEventListener("touchstart", function(e) {
      if (e.touches.length === 2) {
        const dx = e.touches[0].clientX - e.touches[1].clientX;
        const dy = e.touches[0].clientY - e.touches[1].clientY;
        pinchStartDist = Math.hypot(dx, dy);
        pinchStartScale = scale;
        e.preventDefault();
      } else if (e.touches.length === 1) {
        startDrag(e.touches[0].clientX, e.touches[0].clientY);
      }
    }, { passive: false });
    stage.addEventListener("touchmove", function(e) {
      if (e.touches.length === 2 && pinchStartDist > 0) {
        const dx = e.touches[0].clientX - e.touches[1].clientX;
        const dy = e.touches[0].clientY - e.touches[1].clientY;
        const d = Math.hypot(dx, dy);
        const next = pinchStartScale * (d / pinchStartDist);
        const cx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        const cy = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        setScale(next, cx, cy);
        e.preventDefault();
      } else if (e.touches.length === 1 && dragging) {
        moveDrag(e.touches[0].clientX, e.touches[0].clientY);
        e.preventDefault();
      }
    }, { passive: false });
    stage.addEventListener("touchend", function() {
      pinchStartDist = 0;
      endDrag();
    });

    applyTransform();
  }
  document.addEventListener("DOMContentLoaded", initProductZoom);

})();

  // Smooth scroll (v23: also redirect cross-page anchors back to homepage)
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener("click", e => {
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const t = document.querySelector(id);
      if (t) {
        e.preventDefault();
        t.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        // Target not on this page — go to homepage with the anchor (apply page nav, etc.)
        e.preventDefault();
        window.location.href = "/" + id;
      }
    });
  });

  // ============================================================


  // ============================================================
  // Collection SEO — view-more/view-less toggle with localStorage
  // ============================================================
  document.querySelectorAll('[data-rxc-seo]').forEach((wrap) => {
    const btn = wrap.querySelector('.rxc-seo-toggle');
    if (!btn) return;
    const collectionHandle = wrap.getAttribute('data-collection-handle') || 'default';
    const storageKey = 'rxc-seo-expanded-' + collectionHandle;

    // Restore prior preference
    try {
      if (localStorage.getItem(storageKey) === '1') {
        wrap.setAttribute('data-expanded', 'true');
        btn.querySelector('.rxc-seo-toggle-label').textContent = 'Show less';
      }
    } catch (e) { /* localStorage unavailable */ }

    btn.addEventListener('click', () => {
      const expanded = wrap.getAttribute('data-expanded') === 'true';
      wrap.setAttribute('data-expanded', expanded ? 'false' : 'true');
      btn.querySelector('.rxc-seo-toggle-label').textContent = expanded ? 'Read full guide' : 'Show less';
      try {
        localStorage.setItem(storageKey, expanded ? '0' : '1');
      } catch (e) { /* localStorage unavailable */ }
    });
  });


/* v60AE: Mobile scroll-direction header reveal/hide */
(function _rxHeaderScrollReveal(){
  var THRESHOLD = 12;        // ignore tiny jitter
  var REVEAL_AFTER_PX = 80;  // header pinned until you scroll past 80px down
  var lastY = window.pageYOffset || document.documentElement.scrollTop;
  var ticking = false;
  function update() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var header = document.querySelector('header.site');
    if (!header) { ticking = false; return; }
    var isMobile = window.matchMedia('(max-width: 720px)').matches;
    if (!isMobile) { header.classList.remove('is-hidden'); ticking = false; return; }
    var diff = y - lastY;
    if (Math.abs(diff) < THRESHOLD) { ticking = false; return; }
    if (y < REVEAL_AFTER_PX) {
      header.classList.remove('is-hidden');
    } else if (diff > 0) {
      // scrolling down
      header.classList.add('is-hidden');
    } else {
      // scrolling up
      header.classList.remove('is-hidden');
    }
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', function(){
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
})();



/* v60BE: THEME-006 — fallback handlers for buttons whose inline onclick was removed
   (mm-close, nav-toggle, nav-search-btn, rxs-search-close). Defensive — if main
   _rxToggleMobileMenu / _rxCloseMobileMenu helpers are present they handle it,
   but these listeners guarantee the buttons work even if those didn't register. */
(function _rxButtonFallbacks(){
  function attach() {
    var mmClose = document.getElementById("mm-close");
    if (mmClose && !mmClose.dataset.rxBound) {
      mmClose.dataset.rxBound = "1";
      mmClose.addEventListener("click", function(e){
        e.preventDefault();
        if (window._rxCloseMobileMenu) { window._rxCloseMobileMenu(); return; }
        document.body.classList.remove("menu-open");
        var mm = document.getElementById("mobile-menu");
        if (mm) { mm.setAttribute("inert", ""); mm.removeAttribute("aria-hidden"); }
      });
    }
    var navToggle = document.getElementById("nav-toggle");
    if (navToggle && !navToggle.dataset.rxBound) {
      navToggle.dataset.rxBound = "1";
      navToggle.addEventListener("click", function(e){
        if (window._rxToggleMobileMenu) { window._rxToggleMobileMenu(e); return; }
        e.preventDefault();
        document.body.classList.toggle("menu-open");
        var mm = document.getElementById("mobile-menu");
        if (mm) {
          if (document.body.classList.contains("menu-open")) {
            mm.removeAttribute("inert"); mm.removeAttribute("aria-hidden");
          } else {
            mm.setAttribute("inert", ""); mm.removeAttribute("aria-hidden");
          }
        }
      });
    }
    var navSearch = document.getElementById("nav-search-btn");
    if (navSearch && !navSearch.dataset.rxBound) {
      navSearch.dataset.rxBound = "1";
      navSearch.addEventListener("click", function(){
        var ov = document.getElementById("rxs-search-overlay");
        if (ov) {
          ov.classList.toggle("open");
          setTimeout(function(){
            var i = document.getElementById("rxs-search-input");
            if (i) i.focus();
          }, 50);
        }
      });
    }
    var closeBtns = document.querySelectorAll(".rxs-search-close");
    closeBtns.forEach(function(btn){
      if (btn.dataset.rxBound) return;
      btn.dataset.rxBound = "1";
      btn.addEventListener("click", function(){
        var ov = document.getElementById("rxs-search-overlay");
        if (ov) ov.classList.remove("open");
      });
    });
  }
  /* v60CD: expose attach so customizer section:load can re-bind the search button */
  try { window._rxButtonFallbacks = { attach: attach }; } catch (e) {}
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attach);
  } else {
    attach();
  }
})();


// ============================================================
// v60BI — Floatcart wishlist auto-init on EVERY page (not just home)
// Reads rxbWishlist from localStorage on page load and updates the
// floating cart badge + visibility. Independent of the PRODUCTS array
// (which only exists on the home catalog page).
// ============================================================
(function rxbWishlistFloatcartAllPages() {
  // v61: The main script's renderBuilder now runs on EVERY page (loadWishlistFromStorage
  // hydrates `order`, then renderBuilder writes #cart-count / #cart-total / #floatcart
  // visibility using the chosen-tier "Your cost"). This IIFE must NOT overwrite those
  // with the old per-unit (unitPrice) math, or the two would conflict. So refreshFloatcart
  // delegates to renderBuilder when available; otherwise it ONLY toggles floatcart
  // visibility (count-based) without touching the totals text.
  function refreshFloatcart() {
    try {
      // Prefer the canonical tier-based renderer if it's on the page.
      if (window.RebelX && typeof window.RebelX.renderBuilder === 'function') {
        window.RebelX.renderBuilder();
        return;
      }
      var fc = document.getElementById('floatcart');
      if (!fc) return;
      var raw = localStorage.getItem('rxbWishlist');
      var data = null;
      try { data = raw ? JSON.parse(raw) : null; } catch (_) {}
      var items = (data && Array.isArray(data.items)) ? data.items : [];
      var count = items.reduce(function(a, it) { return a + (parseInt(it.cases) || 1); }, 0);
      // Only own visibility here; do NOT write #cart-total / #cart-count (renderBuilder owns them).
      fc.style.display = count > 0 ? 'flex' : 'none';
    } catch (e) {}
  }
  function ensureClickFallback() {
    var fc = document.getElementById('floatcart');
    if (!fc) return;
    // On non-home pages where the builder modal doesn't exist, make
    // the floatcart navigate to the apply page instead of doing nothing.
    var hasBuilder = !!document.getElementById('builder');
    if (!hasBuilder && !fc.dataset.rxbWired) {
      fc.dataset.rxbWired = '1';
      fc.style.cursor = 'pointer';
      fc.addEventListener('click', function(e) {
        if (e.target.closest('a, button')) return;
        window.location.href = '/pages/apply-for-wholesale';
      });
    }
  }
  function init() {
    refreshFloatcart();
    ensureClickFallback();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Cross-tab sync — if wishlist changes in another tab, re-hydrate `order` then re-render
  // (so the tier-based totals reflect the other tab's changes), else just refresh visibility.
  window.addEventListener('storage', function(e) {
    if (e.key !== 'rxbWishlist') return;
    if (window.RebelX && typeof window.RebelX.reloadFromStorage === 'function') {
      window.RebelX.reloadFromStorage();
    } else {
      refreshFloatcart();
    }
  });
  // Expose for manual calls (e.g. from product page add-to-wishlist handlers)
  window.RebelX = window.RebelX || {};
  window.RebelX.refreshFloatcart = refreshFloatcart;
})();

// v60BI — Monkey-patch localStorage.setItem so any write to rxbWishlist
// (from the catalog renderBuilder, from /products/* add-to-wishlist, from
// /pages/apply-for-wholesale, anywhere) immediately refreshes the floatcart.
(function rxbHookLocalStorage() {
  if (window._rxbLSHooked) return;
  window._rxbLSHooked = true;
  try {
    var origSet = localStorage.setItem.bind(localStorage);
    localStorage.setItem = function(key, value) {
      var ret = origSet(key, value);
      if (key === 'rxbWishlist' && window.RebelX && window.RebelX.refreshFloatcart) {
        setTimeout(window.RebelX.refreshFloatcart, 0);
      }
      return ret;
    };
  } catch (e) {}
})();



